<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-12 mt-3">
                        <vs-checkbox v-model="model.accommodationRequired"
                                     :name="'accommodationRequired' + _uid"
                                     :id="'accommodationRequired' + _uid"
                                     :disabled="true"
                                     style="justify-content: flex-start !important"
                                     aria-describedby="accommodationRequiredHelp">
                            {{ $t('participationConfirmation.accommodationRequired') }}
                        </vs-checkbox>
                        <small id="accommodationRequiredHelp" class="form-text text-muted">
                            {{$t('participationConfirmation.accommodationRequiredHelp')}}
                        </small>
                    </div>
                </div>

                <div class="row mb-3" v-if="model.accommodationRequired">
                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'fromDate' + _uid">
                            {{$t('participationConfirmation.fromDate')}}
                        </label>
                        <div class="ml-2"
                             :name="'fromDate' + _uid"
                             :id="'fromDate' + _uid">
                            {{model.fromUtc ? $moment(model.fromUtc).format('DD.MM.YYYY') : ''}}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'toDate' + _uid">{{ $t('participationConfirmation.toDate') }}</label>
                        <div class="ml-2"
                             :name="'toDate' + _uid"
                             :id="'toDate' + _uid">
                            {{model.toUtc ? $moment(model.toUtc).format('DD.MM.YYYY') : ''}}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'accommodationPlace' + _uid">{{ $t('participationConfirmation.accommodationPlace') }}</label>
                        <div class="ml-2"
                             :name="'accommodationPlace' + _uid"
                             :id="'accommodationPlace' + _uid">
                            {{ isEnVersion ? model.accommodationPlaceNameEn : model.accommodationPlaceName }}
                        </div>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold" :for="'toDate' + _uid">{{ $t('participationConfirmation.accommodationType') }}</label>
                        <div class="ml-2"
                             :name="'accommodationType' + _uid"
                             :id="'accommodationType' + _uid">
                            {{ accommodationType }}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-md-6 col-sm-12">
                        <vs-checkbox v-model="model.transportationRequired"
                                     :name="'transportationRequired' + _uid"
                                     :id="'transportationRequired' + _uid"
                                     :disabled="true"
                                     style="justify-content: flex-start !important"
                                     aria-describedby="transportationRequiredHelp">
                            {{ $t('participationConfirmation.transportationRequired') }}
                        </vs-checkbox>
                        <small id="transportationRequiredHelp" class="form-text text-muted">
                            {{$t('participationConfirmation.transportationRequiredHelp')}}
                        </small>
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                        <vs-checkbox v-model="model.vegetarianMenuRequired"
                                     :name="'vegetarianMenuRequired' + _uid"
                                     :id="'vegetarianMenuRequired' + _uid"
                                     :disabled="true"
                                     style="justify-content: flex-start !important"
                                     aria-describedby="vegetarianMenuRequiredHelp">
                            {{ $t('participationConfirmation.vegetarianMenuRequired') }}
                        </vs-checkbox>
                        <small id="vegetarianMenuRequiredHelp" class="form-text text-muted">
                            {{$t('participationConfirmation.vegetarianMenuRequiredHelp')}}
                        </small>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'note' + _uid">{{ $t('participationConfirmation.note') }}</label>
                        <p :id="'note' + _uid">
                            {{model.participationDetailsNote}}
                        </p>
                    </div>
                </div>

                <div v-if="model.confirmedByAdmin">
                    <hr />
                    <div class="row">
                        <div class="col-md-4 col-sm-12 form-group">
                            <vs-checkbox v-model="model.isNotifiedByPhone"
                                         :name="'isNotifiedByPhone' + _uid"
                                         :id="'isNotifiedByPhone' + _uid"
                                         style="justify-content: flex-start !important"
                                         :readonly="true">
                                {{ $t('registers.events.evaluation.tempRanking.isNotifiedByPhone') }}
                            </vs-checkbox>
                        </div>
                        <div class="col-md-4 col-sm-12 form-group" v-if="model.isNotifiedByPhone">
                            <label class="font-weight-bold" :for="'dateOfNotificationUtc' + _uid">{{$t('registers.events.evaluation.tempRanking.dateOfNotificationUtc')}}</label>
                            <DatePicker v-model="model.dateOfNotificationUtc"
                                        format="dd.MM.yyyy HH:mm"
                                        class="form-control"
                                        :name="'dateOfNotificationUtc' + _uid"
                                        :id="'dateOfNotificationUtc' + _uid"
                                        :fieldName="$t('registers.events.evaluation.tempRanking.dateOfNotificationUtc')"
                                        :readonly="true">
                            </DatePicker>
                        </div>
                        <div class="col-md-4 col-sm-12 form-group" v-if="model.isNotifiedByPhone">
                            <label class="font-weight-bold" :for="'phoneOfNotificatiob' + _uid">{{$t('registers.events.evaluation.tempRanking.phoneOfNotification')}}</label>
                            <input type="text"
                                   readonly
                                   class="form-control"
                                   v-model="model.phoneOfNotificatiob"
                                   :name="'phoneOfNotificatiob' + _uid"
                                   :id="'phoneOfNotificatiob' + _uid"/>
                        </div>

                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="text-right mt-3">
                    <div class="btn-group" role="group" aria-label="Accommodation request deatils buttons">
                        <button type="button" class="btn btn-danger" @click.stop="onCancel"><i class="fas fa-ban mr-2"></i>{{ $t('buttons.cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { AccommodationRequestDeatilsModel } from '@/models/models';
    import { Culture } from '@/models/enums';
    import DatePicker from '@/components/datepicker/DateTimePicker';

    export default {
        inject: ['$validator'],
        props: {
            value: {
                type: AccommodationRequestDeatilsModel,
                required: true
            },
        },
        components: {
            DatePicker
        },
        data() {
            return {
                model: this.value
            }
        },
        methods: {
            onCancel() {
                this.$emit("cancel");
            }
        },
        computed: {
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            accommodationType() {
                if (!this.model) {
                    return ''
                }

                if (this.model.singleRoom) {
                    return this.isEnVersion ? 'Single' : 'Единична';
                }

                if (this.model.doubleRoom) {
                    return this.isEnVersion ? 'Double' : 'Двойна';
                }

                if (this.model.tripleRoom) {
                    return this.isEnVersion ? 'Triple' : 'Тройна';
                }

                if (this.model.apartment) {
                    return this.isEnVersion ? 'Apartment' : 'Апартамент';
                }

                return ''
            }
        },
        mounted() {
            // Workaround защото на DatePicker при попълване на тази дата изрично му е зададено да не конвертира датата към UTC
            // и незнам какво ще счупим ако я променим да се записва в UTC
            if (this.model.dateOfNotificationUtc) {
                this.model.dateOfNotificationUtc = new Date(`${this.model.dateOfNotificationUtc}Z`);
            }
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new AccommodationRequestDeatilsModel(this.value);
                }
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
